"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfWatched = checkIfWatched;
var _forceUpdate = require("../force-update");
function checkIfWatched(inputName) {
  return function (getState, dispatch) {
    const {
      watchedNames
    } = getState();
    if (watchedNames.has(inputName)) {
      dispatch((0, _forceUpdate.forceUpdate)());
    }
  };
}